import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const OPERATOR_TOKEN_KEY = 'operator_token';

// Dedicated axios instance for the platform-operator backend. Uses its OWN token
// (separate from the club-user token) so an operator can manage the platform
// without being logged into any single club.
export const opApi = axios.create({ baseURL: `${BACKEND_URL}/api/saas` });

opApi.interceptors.request.use((config) => {
    const token = localStorage.getItem(OPERATOR_TOKEN_KEY);
    config.headers = config.headers || {};
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }
    return config;
});

export const setOperatorToken = (token) => localStorage.setItem(OPERATOR_TOKEN_KEY, token);
export const clearOperatorToken = () => localStorage.removeItem(OPERATOR_TOKEN_KEY);
export const getOperatorToken = () => localStorage.getItem(OPERATOR_TOKEN_KEY);
